export type ConvertTagKind = "project" | "issue"

// Converting moves every thread onto the new Linear item and deletes the tag
// (convertTagToIssue / convertTagToProject), so the confirm has to say so.
export function convertTagDescription(
	kind: ConvertTagKind,
	threadCount: number | undefined,
) {
	const threads =
		threadCount === undefined
			? "all threads"
			: threadCount === 1
				? "its thread"
				: `all ${threadCount} threads`
	return `Creates a Linear ${kind}, moves ${threads} onto it, and removes this tag.`
}
